export const VERSION = "1.4.0";


//////////////////
// WEBPACK FOOTER
// ./~/_axios@1.4.0@axios/lib/env/data.js
// module id = 66
// module chunks = 1